import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { deleteDocument, deleteDocumentFromStore, getPreschoolDetails, setActivePreschoolDocument, getDocumentReadList, clearDocumentReadList } from 'actions/documents';
import { fetch_preschoolgoals } from 'actions/preschoolform';
import { getReaderParameters } from 'actions/user';
import { setPageTitle } from 'actions/header';
import { CardSubtitle } from 'components/Cards/Card';
import Date from 'components/Presentation/Date/Date';
import PostContent from 'components/Presentation/PostContent';
import Documentation from 'containers/Forms/Documentation';
import Modal from 'containers/Modals/Modal';
import { trackImmersiveReaderError } from 'helpers/insights';
import { getRootUrl } from 'helpers/url';
import { isUserTeacher } from 'helpers/user';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import swal from 'sweetalert2';
import { Spinner } from 'UI';
import Block, { BlockContent, BlockWrapper } from 'UI/Elements/Block';
import { Immersive_Reader } from 'UI/Icons';
import { getDescription } from 'helpers/content';
import { Button, Block as ContentBlock, Icon } from '@haldor/ui';
import FileItem from 'components/FileItem';
import ProgressBar from 'UI/Elements/ProgressBar';

var ImmersiveReader = require('@microsoft/immersive-reader-sdk');

var SinglePreschoolDocument = /*#__PURE__*/function (_Component) {
  _inherits(SinglePreschoolDocument, _Component);

  var _super = _createSuper(SinglePreschoolDocument);

  function SinglePreschoolDocument(props) {
    var _this;

    _classCallCheck(this, SinglePreschoolDocument);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.setActivePreschoolDocument();

      ImmersiveReader.close();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props = _this.props,
          match = _this$props.match,
          currentUser = _this$props.currentUser;

      _this.props.getPreschoolDetails(match.params.id).then(function () {
        _this.props.setPageTitle(_this.props.activeDocument.title);

        if (_this.props.activeDocument.creator == currentUser.id || _this.props.activeDocument.editable) {
          _this.props.getDocumentReadList(match.params.id).then(function () {
            _this.setState({
              loadingReadlist: false
            });
          });
        } else {
          _this.props.clearDocumentReadList();
        }
      })["catch"](function (error) {
        if (error.status == 204) {
          _this.props.addError(_this.props.translate("Document has been deleted"), 'error');

          _this.props.history.push('/');
        }
      });

      if (_this.props.preschoolGoals.length < 1) {
        _this.props.fetch_preschoolgoals();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (proxy, skipPrompt) {
      var match = _this.props.match;

      _this.setState({
        modalIsOpen: false
      });

      if (skipPrompt) {
        _this.props.getPreschoolDetails(match.params.id).then(function () {
          _this.props.setPageTitle(_this.props.activeDocument.title);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "editButton", function () {
      if (_this.props.activeDocument == null || _this.props.activeDocument.title == null) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: _this.openModal
      }, _this.props.translate('Edit')));
    });

    _defineProperty(_assertThisInitialized(_this), "deleteModal", function () {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('delete-post-prompt'),
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: _this.props.translate('Cancel'),
        confirmButtonText: _this.props.translate('Delete')
      }).then(function (result) {
        if (result.value != null) {
          _this.props.deleteDocument(_this.props.match.params.id).then(function () {
            _this.props.deleteDocumentFromStore(_this.props.match.params.id);

            _this.props.history.push(getRootUrl());
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteButton", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginTop: 5
        },
        onClick: _this.deleteModal
      }, _this.props.translate('Delete')));
    });

    _defineProperty(_assertThisInitialized(_this), "runImmersiveReader", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props2, activeDocument, currentUser, localLanguage, data, reader;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, activeDocument = _this$props2.activeDocument, currentUser = _this$props2.currentUser;
              localLanguage = localStorage.getItem('language');
              console.log('run Microsoft Immersive Reader', localLanguage, currentUser.id);
              data = {
                title: activeDocument.title,
                chunks: [{
                  content: '<h1>' + activeDocument.title + '</h1>',
                  mimeType: 'text/html'
                }, {
                  content: getDescription(activeDocument.description),
                  mimeType: 'text/html'
                }]
              };
              _context.next = 6;
              return _this.props.getReaderParameters();

            case 6:
              reader = _this.props.reader;
              ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
                uiLang: localLanguage // Set immersive reader UI language to selected lang in Haldor Edu

              })["catch"](function (error) {
                console.error('error', error);
                trackImmersiveReaderError(error, currentUser.id);
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "toggleRelationshipList", function () {
      if (_this.props.readList.length > 200) {
        var _translate = _this.props.translate;
        swal.fire({
          title: '',
          text: _translate('Since the post was shared with more than 200 people, you can not see who read it'),
          showCancelButton: false,
          confirmButtonText: _translate('Ok')
        });
        return true;
      }

      _this.setState({
        relationshipList: !_this.state.relationshipList
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderReadList", function () {
      var _this$props3 = _this.props,
          translate = _this$props3.translate,
          readList = _this$props3.readList;
      var relationshipList = _this.state.relationshipList;

      if (readList != null && readList.length > 200) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Modal, {
        type: "small",
        isOpen: relationshipList,
        overridePrompt: true,
        onClose: _this.toggleRelationshipList,
        title: translate('shared-with')
      }, /*#__PURE__*/React.createElement("div", {
        className: "form single-post-read-list"
      }, readList != null ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "table"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('read-post'))), readList.map(function (read) {
        return read.hasRead ? /*#__PURE__*/React.createElement("div", {
          className: "user-item",
          key: read.userId
        }, read.user.firstName, " ", read.user.lastName, " ", /*#__PURE__*/React.createElement(Icon, {
          name: "Eye"
        })) : null;
      }), /*#__PURE__*/React.createElement("div", null, "\xA0")), /*#__PURE__*/React.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('not-read-post'))), readList.map(function (read) {
        return read.hasRead ? null : /*#__PURE__*/React.createElement("div", {
          className: "user-item",
          key: read.userId
        }, read.user.firstName, " ", read.user.lastName);
      }))))) : /*#__PURE__*/React.createElement("div", {
        className: "color--meta text--center size-12"
      }, _this.props.translate('not-read-post'))));
    });

    _this.state = {
      modalIsOpen: false,
      files: [],
      relationshipList: false,
      loadingReadlist: true
    };
    return _this;
  }

  _createClass(SinglePreschoolDocument, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          activeDocument = _this$props4.activeDocument,
          currentUser = _this$props4.currentUser,
          preschoolGoals = _this$props4.preschoolGoals;
      var isTeacher = isUserTeacher(this.props.currentUser);
      var isCreator = currentUser.id == activeDocument.creator;

      if (activeDocument == null) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      var readCount = 0;
      var percentage = 0;

      if (this.props.readList != null) {
        readCount = _toConsumableArray(this.props.readList).filter(function (read) {
          return read.hasRead;
        }).length;
        percentage = Math.round(100 / this.props.readList.length * readCount);
      }

      return /*#__PURE__*/React.createElement("div", null, this.renderReadList(), isTeacher ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modalIsOpen,
        onClose: this.closeModal,
        title: this.props.translate('edit-document')
      }, /*#__PURE__*/React.createElement(Documentation, {
        onModalClose: this.closeModal
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "single-task single-preschool_document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side",
        style: {
          paddingTop: '0'
        }
      }, /*#__PURE__*/React.createElement(ContentBlock, null, activeDocument.status == 'POST_DRAFT' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.35rem'
        }
      }, this.props.translate('Draft')) : null, /*#__PURE__*/React.createElement("div", {
        className: "single-task-description"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('description')), this.props.services.immersiveReaderPosts ? /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: this.runImmersiveReader
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), this.props.translate('immersive-reader'))) : null, /*#__PURE__*/React.createElement(PostContent, null, activeDocument.description)), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('date')), /*#__PURE__*/React.createElement(CardSubtitle, null, /*#__PURE__*/React.createElement(Date, null, activeDocument.created))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('column-created-by')), activeDocument.author != null ? /*#__PURE__*/React.createElement(CardSubtitle, null, activeDocument.author) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('shared-with')), activeDocument.relationships != null ? activeDocument.relationships.map(function (relationship) {
        return /*#__PURE__*/React.createElement("div", {
          key: relationship.referenceId
        }, relationship.referenceTitle);
      }) : null)), /*#__PURE__*/React.createElement(BlockWrapper, {
        cols: "2"
      }, activeDocument.associatedGoals && activeDocument.associatedGoals.length > 0 && preschoolGoals && preschoolGoals.length > 0 ? /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(BlockContent, null, activeDocument.associatedGoals.map(function (goal) {
        var goalObject = preschoolGoals.find(function (gb) {
          return gb.id == goal.goalId;
        });

        if (goalObject) {
          return /*#__PURE__*/React.createElement("div", {
            key: goalObject.id,
            style: {
              backgroundColor: goalObject.colorCode
            },
            "data-tooltip": goalObject.text,
            className: "goal-preview"
          }, goalObject.title);
        }

        return null;
      }))) : null), activeDocument.associatedFiles != null && activeDocument.associatedFiles.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "preschool-gallery"
      }, /*#__PURE__*/React.createElement(BlockWrapper, {
        cols: "2"
      }, activeDocument.associatedFiles.map(function (file, index) {
        if (file.type != null && file.type.indexOf('image') > -1) {
          return /*#__PURE__*/React.createElement(Block, {
            key: "file-".concat(file.id, "-").concat(index)
          }, /*#__PURE__*/React.createElement(FileItem, {
            file: file,
            style: {
              width: '100%',
              height: '100%',
              display: 'block',
              borderRadius: 'inherit'
            }
          }));
        }

        if (file.type != null) {
          return /*#__PURE__*/React.createElement(Block, {
            key: "file-".concat(file.id, "-").concat(index)
          }, /*#__PURE__*/React.createElement(FileItem, {
            file: file
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              padding: '0.755rem'
            }
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              display: 'inline-block',
              position: 'relative',
              top: 3,
              marginRight: '0.25rem'
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "File"
          })), file.name)));
        }

        return null;
      }))) : null), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }, activeDocument.planId != null ? /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('tools')), /*#__PURE__*/React.createElement(Link, {
        to: "/plan/".concat(activeDocument.planId)
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary"
      }, this.props.translate('plan')))) : null, /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, activeDocument.planId != null || !activeDocument.editable ? null : /*#__PURE__*/React.createElement("h3", null, this.props.translate('tools')), isCreator || activeDocument.editable ? this.editButton() : null, isCreator || activeDocument.deletable ? this.deleteButton() : null, this.props.readList != null && !this.state.loadingReadlist ? /*#__PURE__*/React.createElement("div", {
        className: "single-post-read-list-trigger",
        onClick: this.toggleRelationshipList
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Eye"
      }), readCount, "/", this.props.readList.length, " ", this.props.translate('have-read')) : null, this.props.readList != null && this.props.readList.length > 0 && !this.state.loadingReadlist ? /*#__PURE__*/React.createElement("div", {
        style: {
          width: 230
        }
      }, /*#__PURE__*/React.createElement(ProgressBar, {
        percentage: percentage,
        fillColor: "var(--color--meta)"
      })) : null)), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      })));
    }
  }]);

  return SinglePreschoolDocument;
}(Component);

function mapStateToProps(state) {
  return {
    services: state.Services.availableServices,
    activeDocument: state.Documents.activeDocument,
    preschoolDocuments: state.Documents.documents,
    readList: state.Documents.readList,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations),
    preschoolGoals: state.PreschoolGoals.preschoolGoals,
    reader: state.user.reader
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setActivePreschoolDocument: setActivePreschoolDocument,
    fetch_preschoolgoals: fetch_preschoolgoals,
    getPreschoolDetails: getPreschoolDetails,
    clearDocumentReadList: clearDocumentReadList,
    deleteDocument: deleteDocument,
    deleteDocumentFromStore: deleteDocumentFromStore,
    getReaderParameters: getReaderParameters,
    getDocumentReadList: getDocumentReadList,
    setPageTitle: setPageTitle
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SinglePreschoolDocument));